import api from './api';

// 연락 관련 API 호출 함수들
export const contactApi = {
  // 이메일 전송
  sendEmail: async (form) => {
    const response = await api.postPublic('/contact', form);
    return response.data;
  },
};
